{
  "el": {
    "sales": {
      "actions": {
        "assign_lead": "Ανάθεση lead",
        "publish": "Δημοσίευση",
        "remove_lead_from_deal": "Αφαίρεση lead από την ευκαιρία",
        "unpublish": "Κατάργηση δημοσίευσης",
        "update_status": "Ενημέρωση κατάστασης",
        "upload_document": "Ανέβασμα συμβολαίου",
        "view_contracts": "Προβολή συμβολαίων"
      },
      "attributes": {
        "status": "Κατάσταση"
      },
      "labels": {
        "assign_customer": "Ανάθεση πελάτη",
        "assign_customer_mark_sold": "Ανάθεσε πελάτη για να σημειωθεί ως πωλημένο",
        "assign_lead_to_unit": "Ανάθεση lead σε ακίνητο",
        "assigned_by": "Ανατέθηκε από",
        "contracts": "Συμβόλαια",
        "expiry_date": "Ημερομηνία λήξης κράτησης",
        "go_to_unit_part_1": "Αυτό το ακίνητο πουλήθηκε. Αν θέλεις να ενημερώσεις την κατάσταση, πρέπει να πας στη",
        "go_to_unit_part_2": "και να αφαιρέσεις πρώτα τον πελάτη από εκεί, για λόγους ασφαλείας.",
        "interested_leads": "{count} leads με ενδιαφέρον",
        "internal_note": "Εσωτερική σημείωση",
        "latest_phase": "Τελευταία φάση",
        "lead_existing": "Υπάρχον lead",
        "lead_new": "Νέο lead",
        "leads_count": "{count} leads",
        "mark_as_sold": "Σήμανση ως πωλημένο",
        "not_published_sales_partners": "Μη δημοσιευμένο για συνεργάτες πωλήσεων",
        "not_shown_interest": "Αυτό το lead δεν έχει δείξει ενδιαφέρον για κανένα ακίνητο",
        "note_explainer": "Αυτή η σημείωση είναι ορατή μόνο στην ομάδα σου",
        "publish_unit": "Δημοσίευση 1 ακινήτου για όλους τους συνεργάτες πωλήσεων | Δημοσίευση {count} ακινήτων για όλους τους συνεργάτες πωλήσεων",
        "published_sales_partners": "Δημοσιευμένο για συνεργάτες πωλήσεων",
        "reserved_by": "Κρατήθηκε από",
        "reserved_warning": "Αυτό το ακίνητο είναι κρατημένο από {lead_name}. Αν το σημειώσεις ως πωλημένο, η κράτηση θα ακυρωθεί.",
        "sales": "Πωλήσεις",
        "selling_price": "Τιμή πώλησης",
        "selling_price_max": "Μέγιστη τιμή πώλησης",
        "selling_price_min": "Ελάχιστη τιμή πώλησης",
        "sold_date": "Πωλήθηκε στις",
        "sorting": {
          "deal_lead_group_name": "Lead",
          "deal_status": "Κατάσταση",
          "name": "Ακίνητο"
        },
        "status": "Κατάσταση",
        "statuses": {
          "available": "Διαθέσιμο",
          "interested": "Ενδιαφέρον",
          "lost": "Χαμένο",
          "reserved": "Κρατημένο",
          "sold": "Πωλημένο"
        },
        "tab_sales_documents": "Έγγραφα",
        "tab_sales_tickets": "Συνομιλίες",
        "tab_sales_units": "Ακίνητα",
        "unit": "Ακίνητο",
        "unit_information_page": "σελίδα πληροφοριών του ακινήτου",
        "unit_sales_status_header": "Αυτό το ακίνητο είναι προς πώληση",
        "unpublish_unit": "Κατάργηση δημοσίευσης 1 ακινήτου για όλους τους συνεργάτες πωλήσεων | Κατάργηση δημοσίευσης {count} ακινήτων για όλους τους συνεργάτες πωλήσεων",
        "update_sales_status": "Ενημέρωση κατάστασης πώλησης ακινήτου",
        "upload_sales_doc": "Ανέβασμα συμβολαίου"
      },
      "toasts": {
        "lead_assigned": "Το lead ανατέθηκε"
      },
      "validation": {
        "already_reserved_sold": "Αυτό το ακίνητο είναι ήδη κρατημένο για άλλο lead",
        "already_reserved_sold_info": "Αν θέλεις οπωσδήποτε να αλλάξεις την κατάσταση για το τρέχον lead, πρέπει πρώτα να αλλάξεις την κατάσταση της ευκαιρίας που έχει αυτή τη στιγμή προτεραιότητα. Μόλις την αλλάξεις, μπορείς να επιστρέψεις και να ενημερώσεις με ασφάλεια την κατάσταση.",
        "need_sold_date": "Χρειάζεται η ημερομηνία της πώλησης",
        "reserved_expiry_date": "Χρειάζεται ημερομηνία λήξης για αυτή την κράτηση"
      }
    }
  }
}
